export enum CheckoutSegmentCategory {
  TIME_OF_WEEK = "TIME_OF_WEEK",
  LOCATION = "LOCATION",
  CART_VALUE = "CART_VALUE",
  CART_ITEM_COUNT = "CART_ITEM_COUNT",
  TIME_OF_DAY = "TIME_OF_DAY",
  CUSTOMER_TYPE = "CUSTOMER_TYPE",
  NONE = "NONE",
}

export const checkoutSegmentCategoryDisplayText: Record<
  Exclude<CheckoutSegmentCategory, CheckoutSegmentCategory.NONE>,
  string
> = {
  [CheckoutSegmentCategory.TIME_OF_WEEK]: "Time of week",
  [CheckoutSegmentCategory.LOCATION]: "Location",
  [CheckoutSegmentCategory.CART_VALUE]: "Cart value",
  [CheckoutSegmentCategory.CART_ITEM_COUNT]: "Cart item count",
  [CheckoutSegmentCategory.TIME_OF_DAY]: "Time of day",
  [CheckoutSegmentCategory.CUSTOMER_TYPE]: "Customer type",
};
